<header class="header top-fix ">
  <nav class="navbar navbar-expand-lg navbar bg-light py-0">
    <div class="container-fluid">
      <div class="row my-2 align-items-center">
        <!-- Mobile: Hamburger menu on left -->
        <div class="d-block d-md-none col-auto ps-2 pe-0 my-auto">
          <button class="navbar-toggler p-1" type="button" (click)="toggleSidebar()" id="mobile-sidebar-toggle">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>
        
        <!-- Logo -->
        <div class="col-auto my-auto">
          <img src="{{image}}" style="height:50px">
        </div>
        
        <!-- Desktop: Empty column -->
        <div class="d-md-block d-none col-md-2 my-auto">
        </div>
        <!-- Desktop: Member Portal title -->
        <div class="d-md-block d-none col-md-2 my-auto text-end">
          <div id="title"><b>{{lang?.Member_Portal}}</b></div>
        </div>
        
        <!-- Desktop: Health | Dental | Wellness -->
        <div class="d-md-block d-none col-md-3 my-auto text-end" *ngIf="!waddelCustomer">
          <div id="title"><b>{{lang?.Health}} | {{lang?.Dental}} | {{lang?.Wellness}}</b></div>
        </div>
        <div class="d-md-block d-none col-md-3 my-auto text-end" *ngIf="waddelCustomer">
        </div>
        
        <!-- Mobile: Member Portal text -->
        <div class="d-md-none d-block col my-auto px-1" >
          <div id="title" class="mobile-title"><b>{{lang?.Member_Portal}}</b></div>
          <div id="title" class="mobile-subtitle" *ngIf="!waddelCustomer"><b>{{lang?.Health}} | {{lang?.Dental}} | {{lang?.Wellness}}</b></div>
        </div>
        <!-- Desktop: Language selector and menu -->
        <div class="d-md-block d-none col-md-2 offset-md-1 my-auto">
                    <select class="languagefont" (change)="language($event)" [value]="lang1">
            <option value="English">English</option>
            <option value="French">Français</option>
            <option value="Spanish">Española</option>
          </select>
                    <button class="btn d-none d-md-block" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        <div class="dot rounded"></div>
            <div class="dot rounded"></div>
            <div class="dot rounded"></div>
          </button>
          <ul class="dropdown-menu listRight" id="dropdown-menu-profiles"aria-labelledby="dropdownMenuButton1">
                          <li><a class="dropdown-item"  (click)="changepassword()" style="cursor:pointer"><i class="fa fa-key" aria-hidden="true"></i>&nbsp;<span>{{lang?.Change_Password}}</span></a></li>
              <li><a class="dropdown-item d-flex align-items-center" (click)="logout()"> <i class="bi bi-box-arrow-right" ></i>&nbsp;<span>{{lang?.Logout}}</span> </a></li>


          </ul> 
        </div>

        <!-- Mobile: Language selector and dropdown menu -->
        <div class="d-md-none d-block col-auto my-auto pe-2">
          <select class="languagefont" (change)="language($event)" [value]="lang1">
            <option value="English">En</option>
            <option value="French">Fr</option>
            <option value="Spanish">Es</option>
          </select>
          <button class="btn p-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="dot rounded"></div>
            <div class="dot rounded"></div>
            <div class="dot rounded"></div>
          </button>
          <ul class="dropdown-menu listRight" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item"  (click)="changepassword()" style="cursor:pointer"><i class="fa fa-key" aria-hidden="true"></i>&nbsp;<span>{{lang?.Change_Password}}</span></a></li>
              <li><a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="logout()"> <i class="bi bi-box-arrow-right" ></i>&nbsp;<span>{{lang?.Logout}}</span> </a></li>
          </ul>
        </div>

              </div>
          </div>
  </nav>
</header>

<!-- Change Password modal -->
<div class="modal" id="changepassword" tabindex="-1" role="dialog" aria-labelledby="changepasswordLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top:200px">
      <div class="modal-header">
        <h6 class="modal-title">{{lang?.Change_Password}}</h6>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closeChangepassmodel()"></i>
      </div>
      <div class="modal-body">
      <form [formGroup]="changepasswordform">
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.Old_Password}}<span style="color: red">*</span></label>
          <input type="password" class="form-control checking-field" id="nameofcorporation" placeholder="Old Password" formControlName="oldpassword" (input)="checkpassword()"/>
          <div *ngIf="changepass['oldpassword'].touched && changepass['oldpassword'].invalid" class="help-block text-danger">
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['required']">{{lang?.Please_enter_old_password}}</div>
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
          </div>
        </div>
        <div class="form-group col-1"></div>
      </div>
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.New_Password}}<span style="color: red">*</span></label>
          <input type="password" [ngClass]="{'disabled': changepass['oldpassword'].invalid}" class="form-control checking-field" id="nameofcorporation" placeholder="New Password" formControlName="newpassword" (input)="checkpassword()"/>
          <div *ngIf="changepass['newpassword'].touched && changepass['newpassword'].invalid && changepass['oldpassword'].valid" class="help-block text-danger">
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['required']">{{lang?.Please_enter_new_password}}</div>
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
            
          </div>
          <div class="help-block text-danger" *ngIf="checknewpassword">Old password and new password both are same.</div>

        </div>
        <div class="form-group col-1"></div>
      </div>
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.Confirm_Password}}<span style="color: red">*</span></label>
          <input type="password" [ngClass]="{'disabled': changepass['oldpassword'].invalid || changepass['newpassword'].invalid}" class="form-control checking-field" id="nameofcorporation" placeholder="Confirm Password" formControlName="confirmpassword" (input)="checkpassword()"/>
          <div *ngIf="changepass['confirmpassword'].touched && changepass['confirmpassword'].invalid && changepass['oldpassword'].valid && changepass['newpassword'].valid" class="help-block text-danger">
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['required']">{{lang?.Please_enter_confirm_password}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['confirmedValidator']">{{lang?.Passwords_did_not_match}}</div>
          </div>
        </div>
        <div class="form-group col-1"></div>
      </div>
    </form>
  </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="submitButton" [disabled]="changepasswordform.invalid"  (click)="SubmitChangePassword()">{{lang?.Submit}}</button>
        <button type="button" class="btn btn-sm btn-light" id="cancelButton" data-dismiss="modal" (click)="closeChangepassmodel()"><b>{{lang?.Close}}</b></button>
      </div>
    </div>
  </div>
</div>


<!-- Update Password -->
<div class="modal" id="updatepassword" tabindex="-1" role="dialog" aria-labelledby="changepasswordLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top:200px">
      <div class="modal-header">
        <h6 class="modal-title">{{lang?.Change_Password}}</h6>
              </div>
      <div class="modal-body">
      <form [formGroup]="changepasswordform">
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.Old_Password}}<span style="color: red">*</span></label>
          <input type="password" class="form-control checking-field" id="nameofcorporation" placeholder="Old Password" formControlName="oldpassword"/>
          <div *ngIf="changepass['oldpassword'].touched && changepass['oldpassword'].invalid" class="help-block text-danger">
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['required']">{{lang?.Please_enter_old_password}}</div>
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['oldpassword'].errors && changepass['oldpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
          </div>
        </div>
        <div class="form-group col-1"></div>
      </div>
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.New_Password}}<span style="color: red">*</span></label>
          <input type="password" [ngClass]="{'disabled': changepass['oldpassword'].invalid}" class="form-control checking-field" id="nameofcorporation" placeholder="New Password" formControlName="newpassword"/>
          <div *ngIf="changepass['newpassword'].touched && changepass['newpassword'].invalid && changepass['oldpassword'].valid" class="help-block text-danger">
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['required']">{{lang?.Please_enter_new_password}}</div>
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['newpassword'].errors && changepass['newpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
          </div>
        </div>
        <div class="form-group col-1"></div>
      </div>
      <div class="row">
        <div class="form-group col-1"></div>
        <div class="form-group col-10">
          <label for="Corporation" class="Corporation" id="modal-labels">{{lang?.Confirm_Password}}<span style="color: red">*</span></label>
          <input type="password" [ngClass]="{'disabled': changepass['oldpassword'].invalid || changepass['newpassword'].invalid}" class="form-control checking-field" id="nameofcorporation" placeholder="Confirm Password" formControlName="confirmpassword"/>
          <div *ngIf="changepass['confirmpassword'].touched && changepass['confirmpassword'].invalid && changepass['oldpassword'].valid && changepass['newpassword'].valid" class="help-block text-danger">
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['required']">{{lang?.Please_enter_confirm_password}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['minlength']">{{lang?.Password_must_be_at_least_8_characters}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['maxlength']">{{lang?.Password_must_not_exceed_40_characters}}</div>
            <div *ngIf="changepass['confirmpassword'].errors && changepass['confirmpassword'].errors['confirmedValidator']">{{lang?.Passwords_did_not_match}}</div>
          </div>
        </div>
        <div class="form-group col-1"></div>
      </div>
    </form>
  </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="submitButton" [disabled]="changepasswordform.invalid"  (click)="SubmitUpdatePassword()">{{lang?.Submit}}</button>
              </div>
    </div>
  </div>
</div>

<!-- News letter Modal -->
<div id="newletters2" class="modal modal-lg modalposition" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content">
          <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title" *ngIf="headername!='ehn'">{{headername | titlecase}} Newsletter</h6>
              <h6 class="modal-title" *ngIf="headername=='ehn'">{{headername | uppercase}} Newsletter</h6>
              <i class="bi bi-x-circle" role="button" (click)="closeNewsletter()"></i>
          </div>
          <div class="modal-body">
              <div >
                  <pdf-viewer [src]="link" id="pdf-viewer"></pdf-viewer>
              </div>
          </div>
          <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" id="cancelButton" (click)="closeNewsletter()"><b>{{lang?.Close}}</b></button>
          </div>
      </div>
  </div>
</div>

<!-- Website Modal -->
<div id="website" class="modal modal-lg modalposition" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
      <div class="modal-content" id="modal-content">
          <div class="modal-header" id="backgroundColor">
              <h6 class="modal-title">{{websitetitle}}</h6>
              <i class="bi bi-x-circle" role="button" (click)="closewebsitemodal()"></i>
          </div>
          <div class="modal-body">
            <div>
              <iframe *ngIf="websitelink" [src]='websitelink' width='100%' id="pdf-viewer"></iframe>
            </div>
          </div>
          <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" id="cancelButton" (click)="closewebsitemodal()"><b>{{lang?.Close}}</b></button>
          </div>
      </div>
  </div>
</div>

<app-welcome-bar *ngIf="false" [lang]="lang"></app-welcome-bar>
